import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { CleanFilterBtn } from "../doc-lib-components/Views/Filters-styles";
import { useTranslation } from "react-i18next";
import MapContext from "../../../application/Context/MapContext";
export var CleanFilters = function () {
    var t = useTranslation(["news"]).t;
    var resetFilters = React.useContext(MapContext).resetFilters;
    return (_jsx(CleanFilterBtn, { onClick: resetFilters, children: t("Réinitialiser la recherche") }));
};
